let trustC = () => {
	$('.owl-carousel').owlCarousel({
		loop: false,
		dots: false,
		responsive: {
			0: {
				items: 2,
			},
			640: {
				items: 3,
				nav: true,
			},
			992: {
				items: 3,
				margin: 5,
				nav: false,
			},
			1000: {
				items: 4,
				margin: 30,
			},
		},
		nav: true,
		navText: ['<i class="fa-solid fa-circle-arrow-left"></i>', '<i class="fa-solid fa-circle-arrow-right"></i>'],
	});
};

trustC();

$(window).resize(function () {
	trustC();
	console.log('first');
});
